module.exports = __webpack_public_path__ + "mt-logo-2015.svg?663ce2610aa4f00b2a639c009eeb5f3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mt-logo-2015.svg
// module id = 640
// module chunks = 0